// extracted by mini-css-extract-plugin
export default {"pricingButton":"GAbOq","icon":"wWhGu"};